/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantCreateResponse {
    getFixupPrototypeFunction() { return TenantCreateResponse.fixupPrototype; }

    static newInstance(model: Partial<TenantCreateResponse>): TenantCreateResponse {
        let obj = Object.assign(new TenantCreateResponse(), model);
        TenantCreateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantCreateResponse>): TenantCreateResponse {
        if (!model) return null;
        return TenantCreateResponse.newInstance(<TenantCreateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantCreateResponse) {
        if (!obj) return;

        models.TenantCreateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantCreateResponse): boolean {
        Object.setPrototypeOf(obj, TenantCreateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the newly created tenant. This will be used for performing tenant level operations such as createPolicy, createScript, onboardCloudAccount and so on.
     */
    tenant_id: string;

}
